<template>
    <BreadCrumb PageTitle="Liste des notifications de redevance" />
    <ListeNotificationRedevance />
  </template>
  
  <script lang="ts">
  import { defineComponent } from "vue";
  
  import BreadCrumb from "../../components/Common/BreadCrumb.vue";
  import ListeNotificationRedevance from "../../components/Notification/ListeNotificationRedevance.vue";
  
  
  export default defineComponent({
    name: "ListeNotificationRedevancePage",
    components: {
      BreadCrumb,
      ListeNotificationRedevance,
    },
  });
  </script>